import AnswerSelectionComponent from '../Components/AnswerSelectionComponent';
import EsgAnswerComponent from '../Components/EsgAnswerComponent';
import EsgQuestionComponent from '../Components/EsgQuestionComponent';
import JsonReader from './JsonReader';

class HierarchicalJsonReader extends JsonReader {
  title = 'Hierarchical Json Structure';

  displayItems() {
    this.displayItem(this.json[0]);
  }

  displayItem(esgItem) {
    this._addContents(
      EsgQuestionComponent(
        esgItem,
        this.renderEsgItemAnswers(esgItem),
        this.renderEsgItemAnswersDebug(esgItem)
      )
    );

    if (esgItem.children) {
      esgItem.children.map((answer) => this.displayItem(answer)).join('');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  renderEsgItemAnswers(esgItem) {
    if (esgItem.children.length) {
      return esgItem.children
        .map((answerItem) => AnswerSelectionComponent(answerItem, esgItem))
        .join('');
    }
    return 'keine Antworten vorhanden';
  }

  // eslint-disable-next-line class-methods-use-this
  renderEsgItemAnswersDebug(esgItem) {
    if (esgItem.children.length) {
      return esgItem.children.map((answerItem) => EsgAnswerComponent(answerItem)).join('');
    }
    return 'keine Antworten vorhanden';
  }
}

export default HierarchicalJsonReader;
